<template>
  <div>
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <h4 class="mb-2">
          Histórico de Folha
        </h4>
        <b-row>
          <b-col
            cols="12"
            md="3"
            xl="2"
          >
            <b-form-group
              label="Ano"
              label-for="filter-year"
            >
              <v-select
                v-model="filterYear"
                :options="yearOptions"
                :reduce="val => val.value"
                :clearable="false"
                input-id="filter-year"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="3"
            xl="2"
          >
            <b-form-group
              label="Mês"
              label-for="filter-month"
            >
              <v-select
                v-model="filterMonth"
                :options="monthOptions"
                :reduce="val => val.value"
                :clearable="false"
                input-id="filter-month"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="6"
            xl="4"
          >
            <label for="institution-id">Instituição</label>
            <v-select
              id="institution-id"
              v-model="institutionId"
              name="institution-id"
              :options="institutionOptions"
              label="label"
              item-value="value"
              item-text="label"
            >
              <span slot="no-options">Nenhuma instituição encontrada.</span>
            </v-select>
          </b-col>
          <b-col
            cols="12"
            md="6"
            xl="2"
          >
            <div class="d-flex align-items-start justify-content-start mt-2">
              <div>
                <p class="mr-1">
                  Exibir removidos?
                </p>
              </div>
              <b-form-checkbox
                :checked="includeCanceled"
                class="custom-control-secondary"
                name="check-button"
                switch
                @input="includeCanceled = !includeCanceled"
              >
                <span class="switch-icon-left">
                  <feather-icon icon="CheckIcon" />
                </span>
                <span class="switch-icon-right">
                  <feather-icon icon="XIcon" />
                </span>
              </b-form-checkbox>
            </div>
          </b-col>
          <b-col
            cols="12"
            md="6"
            xl="2"
          >
            <label class="invisible d-none d-md-block">Ações</label>
            <div class="d-flex justify-content-end">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="btn-icon"
                @click="search"
              >
                Buscar
                <feather-icon
                  icon="SearchIcon"
                  size="16"
                />
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refPayrollHistoryTable"
        class="position-relative"
        :items="fetchItems"
        responsive
        :fields="tableColumns"
        primary-key="id"
        show-empty
        empty-text="Nenhum registro correspondente encontrado"
      >
        <template #cell(institution_name)="{ item }">
          <div :title="item.institution_name">
            {{ truncateString(item.institution_name, 40) }}
          </div>
        </template>

        <template #cell(workplace_name)="{ item }">
          <div :title="item.workplace_name">
            <div>{{ truncateString(item.workplace_name, 40) }}</div>
            <b-badge
              v-if="item.canceled"
              pill
              variant="light-danger"
              :title="item.motive"
            >
              Removido
            </b-badge>
          </div>
        </template>

        <template #cell(actions)="{ item }">
          <b-dropdown
            v-if="!item.canceled"
            variant="link"
            toggle-class="p-0"
            no-caret
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item @click="openCancel(item)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Remover</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>

      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label class="mt-0 mb-0">Exibir</label>
            <v-select
              v-model="perPage"
              :options="perPageOptions"
              :clearable="false"
              :searchable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label class="mt-0 mb-0">entradas</label>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalItems"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <payroll-history-cancel-modal
      ref="payrollHistoryCancelModal"
      @refetch-data="refetchData"
    />
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BTable,
  BBadge,
  BPagination,
  BButton,
  BFormGroup,
  BFormCheckbox,
  BDropdown,
  BDropdownItem,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import { onUnmounted, ref } from '@vue/composition-api'
import vSelect from 'vue-select'
import { truncateString } from '@core/utils/utils'
import reportStoreModule from '../../reportStoreModule'
import useWorkplacePayrollHistoryList from './useWorkplacePayrollHistoryList'
import PayrollHistoryCancelModal from './payroll-history-cancel/PayrollHistoryCancelModal.vue'

export default {
  components: {
    PayrollHistoryCancelModal,
    BCard,
    BRow,
    BCol,
    BTable,
    BBadge,
    BPagination,
    BButton,
    BFormGroup,
    BFormCheckbox,
    BDropdown,
    BDropdownItem,
    vSelect,
  },
  directives: {
    Ripple,
  },
  methods: { truncateString },
  setup() {
    const STORE_MODULE_NAME = 'app-reports'

    // Register module
    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, reportStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
    })

    const payrollHistoryCancelModal = ref(null)

    function openCancel(item) {
      payrollHistoryCancelModal.value.show(item)
    }

    const {
      fetchItems,
      fetchInstitutions,
      tableColumns,
      perPage,
      perPageOptions,
      currentPage,
      totalItems,
      refPayrollHistoryTable,
      refetchData,
      search,
      filterYear,
      filterMonth,
      yearOptions,
      monthOptions,
      institutionId,
      institutionOptions,
      includeCanceled,
    } = useWorkplacePayrollHistoryList()

    fetchInstitutions()

    return {
      fetchItems,
      tableColumns,
      perPage,
      perPageOptions,
      currentPage,
      totalItems,
      refPayrollHistoryTable,
      refetchData,
      search,
      filterYear,
      filterMonth,
      yearOptions,
      monthOptions,
      institutionId,
      institutionOptions,
      includeCanceled,
      payrollHistoryCancelModal,
      openCancel,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

label {
  margin-top: 0.2857rem!important;
}
</style>
